/**
 * Returns a profile scoped to one connection. Connection() overwrites `call` on
 * whatever client it is handed, so every scope gets a client nobody else holds.
 * `createClient` is injected rather than imported: this module must stay free of
 * browser-coupled imports so Node can load it directly under `node --test`.
 */
export const createScopedProfile = (connectionId, createClient) => {
  const client = createClient()
  return connectionId ? client.profile.Connection(connectionId) : client.profile
}
